import { PerspectiveCamera } from 'three';

import { SceneObjectBounds } from '@paragon/three-shared';

import { CameraType } from '../store/slices/camera/types';
import { ANTI_ZOOM_FACTOR_PER_VIEWPORT_HEIGHT, updateAntiZoomFactor } from './antiZoom';
import { DesignClientCameraMethods } from './DesignClientCamera';
import { getLayoutModeCameraControls } from './reactThreeFiberBindings';

const FOV = 75;

export const NEAR_FRUSTUM = 0.1;
export const FAR_FRUSTUM = 10000;

export class PerspectiveLayoutCamera extends PerspectiveCamera implements DesignClientCameraMethods {
  public type: CameraType = 'perspective-layout';

  constructor(aspect: number) {
    super(FOV, aspect, NEAR_FRUSTUM, FAR_FRUSTUM);
  }

  updateViewportSize(clientWidth: number, clientHeight: number) {
    this.aspect = clientWidth / clientHeight;
    this.updateProjectionMatrix();
  }

  updateProjectionMatrix() {
    super.updateProjectionMatrix();
    updateAntiZoomFactor(this.getAntiZoomFactor());
  }

  getCurrentBounds(): SceneObjectBounds {
    return {
      position: { x: this.position.x, y: -this.position.z },
      size: { width: 0, height: 0 }, // TODO: not implemented for 3D, we need a better camera
    };
  }

  focusTo(cameraFocusBounds: SceneObjectBounds) {
    this.position.set(
      cameraFocusBounds.position.x,
      cameraFocusBounds.desiredHeight ?? this.position.y,
      -cameraFocusBounds.position.y,
    );
    this.updateProjectionMatrix();

    getLayoutModeCameraControls().target.set(cameraFocusBounds.position.x, 0, -cameraFocusBounds.position.y);
  }

  getAntiZoomFactor(): number {
    return (
      ((this.position.y * (1.9 * Math.tan((Math.PI * this.fov) / 360))) / this.zoom) *
      ANTI_ZOOM_FACTOR_PER_VIEWPORT_HEIGHT
    );
  }
}
